import React from "react";
import styles from "../../../views/DetailMDR/DetailMDR.module.css";
import ReferenceScoreRange from "../../ReferenceScoreRange/ReferenceScoreRange";
import "../../ReferenceScoreRange/ReferenceScoreRange.css";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { FcStatistics } from "react-icons/fc";

const TableMDR = ({ data }) => {
  const riskColors = {
    1: "#5fbf49",
    2: "#f6e502",
    3: "#f49e01",
    4: "#ff7089",
    5: "red",
  };

  // Predefinir los valores para "Factor de riesgo" y "Variable"
  const combinedValues = data
    ? [
      {
        factorRiesgo: "Ingresos",
        variable: "Monto Transaccional Anual",
        valorObtenido: data.EconomicInformation.IncomeOfHumanPerson,
        riesgoObtenido: data.MDR.Income.value,
      },
      {
        factorRiesgo: "Ubicacion - Zona Geografica",
        variable: "Provincia",
        valorObtenido: data.province,
        riesgoObtenido: data.MDR.GeographicLocation.value,
      },
      {
        factorRiesgo: "Actividad que desarrolla",
        variable: "Actividades AFIP",
        valorObtenido: data.EmployerInformation.ActivityBeingCarriedOut,
        riesgoObtenido: data.MDR.ActivityBeingCarriedOut.value,
      },
      {
        factorRiesgo: "Antigüedad en la actividad",
        variable: "En REPSAL",
        valorObtenido: data.EmployerInformation.activitySeniority,
        riesgoObtenido: data.MDR.ActivitySeniority.value,
      },
      {
        factorRiesgo: "Tipo de operatoria",
        variable: "En REPSAL",
        valorObtenido: data.RelationshipWithMutual.typeOfCredit,
        riesgoObtenido: data.MDR.TypeOperation.value,
      },
      {
        factorRiesgo: "Tipo de cliente",
        variable: "Persona Humana o Jurídica",
        valorObtenido: data.typeCustomer,
        riesgoObtenido: data.MDR.TypeCustomer.value,
      },
      {
        factorRiesgo: "Presentación de documentación",
        variable: "Documentación",
        valorObtenido: data.MDR.Documentation.data,
        riesgoObtenido: data.MDR.Documentation.value,
      },
      {
        factorRiesgo: "Canal",
        variable: "Físico o Digital",
        valorObtenido: data.MDR.Canal.data,
        riesgoObtenido: data.MDR.Canal.value,
      },
    ]
    : [];

  return (
    <div className={styles.body}>
      {data === null ? (
        <NotReportViewData title="Matriz de riesgo" Icon={FcStatistics} />
      ) : (
        <>
          <div className={styles.bodyTitle}>
            <p>Detalle de la Matriz de Riesgo</p>
          </div>
          <div className={styles.bodySubtitle}>
            <p>Nombre de la Matriz:</p>{" "}
            <p style={{ color: "blue", fontSize: "16px" }}>
              MDR configuración Básica {data.typeCustomer}
            </p>
          </div>
          <ReferenceScoreRange />
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Factor de riesgo</th>
                <th>Variable</th>
                <th>Valor obtenido</th>
                <th>Riesgo obtenido</th>
              </tr>
            </thead>
            <tbody>
              {combinedValues.map((item, index) => (
                <tr key={index}>
                  <td>{item.factorRiesgo}</td>
                  <td>{item.variable}</td>
                  <td>{item.valorObtenido}</td>
                  <td className={styles.numberSquare}>
                    <div
                      className={styles.numberContainer}
                      style={{
                        backgroundColor: riskColors[item.riesgoObtenido],
                      }}
                    >
                      <p>{item.riesgoObtenido}</p>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default TableMDR;